<template>
  <div class="root_frame">
    <div class="root_bg">
      <div class="card_bg">
        <div class="header" :style="{ background: head_color }">
          <div class="title_layout">
            <div class="title">{{ title }}</div>
            <div class="introduction">{{ introduction }}</div>
          </div>
          <img class="img" :src="img_src" />
        </div>
        <div class="label">{{ t('template.featureIntro') }}</div>
        <div class="desc">
          <li class="ul" v-for="item in desc" :key="item">
            {{ item }}
          </li>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, ref, defineProps } from 'vue';
import { useI18n } from 'vue-i18n';
import TemplateRequest from '../../data/TemplateRequest';

const props = defineProps<{
  view_key: string;
}>();

const title = ref('');
const head_color = ref('');
const img_src = ref('');
const introduction = ref('');
const desc = ref<Array<string>>();
const { t } = useI18n();

onMounted(() => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var cardData: any = TemplateRequest.getViewDataByKey(props.view_key);
  title.value = cardData.title;
  console.log('title: ', title.value);
  head_color.value = cardData.head_color;
  img_src.value = cardData.img_src;
  console.log('img_src: ', img_src.value);
  introduction.value = cardData.introduction;
  desc.value = cardData.desc;
});
</script>

<style scoped>
.root_frame {
  width: 100%;
  height: 100%;
}

.root_bg {
  padding: 10px;
  width: 100%;
  height: 100%;
  background-color: lightgray;
  box-sizing: border-box;
}

.card_bg {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  border-radius: 15px;
  background-color: white;
  flex-direction: column;
}

.title_layout {
  margin-top: 20px;
  margin-left: 20px;
}

.title {
  font-size: 22px;
  text-align: left;
  color: white;
}

.introduction {
  margin-top: 5px;
  font-size: 15px;
  text-align: left;
  color: white;
}

.header {
  display: flex;
  width: 100%;
  height: 100px;
  flex-direction: row;
  border-radius: 15px;
  vertical-align: middle;
  background-position: center top;
  background-repeat: no-repeat;
  background-size: cover;
}

.img {
  margin-top: 15px;
  margin-right: 50px;
  margin-left: auto;
  width: 70px;
  height: 70px;
}

.label {
  margin-top: 10px;
  margin-left: 30px;
  width: 100%;
  font-size: 15px;
  font-weight: 800;
  text-align: left;
}

.desc {
  margin-top: 10px;
  width: 100%;
}

.ul {
  margin-left: 20px;
  font-size: 12px;
  text-align: left;
  color: #333840;
  list-style-type: disc;
  line-height: 20px;
}
</style>
